import React, { useState } from "react";
import Pagination from "./Pagination";
import Breadcrumbs from "./Breadcrumbs";

const LayoutActividad = ({ crumbs, pages, children, sidebar, modulo }) => {
  const url = new URL(window.location.href);
  const params = new URLSearchParams(url.search);
  const resumeOnlyMode = params.get("pdf");
  const [sidebarContainer, setSidebarContainer] = useState('');
  const displaySidebar = () => {
    setSidebarContainer(sidebarContainer ? '' : 'responsive-sidebar')
  }

  return (
    <div className="d-flex flex-wrap">
      {!resumeOnlyMode && (
        <div className={'container-sidebar ' + sidebarContainer} >
          <div className={`btn-sidebar btn btn-${modulo.color} w-100`} onClick={displaySidebar}>
            {modulo.name}: Lista de actividades
          </div>
          {sidebar}
        </div>
      )}

      <div className="container content-module content" id="pdf">
        <Breadcrumbs crumbs={crumbs} modulo={modulo} />

        {children}
        <Pagination pages={pages} />
      </div>
    </div>
  );
};

export default LayoutActividad;
